var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMoney(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M8.552 8c-.542 0-.546.85 0 .842h18.207c.236 0 .413.18.413.421v10.948c0 .555.828.555.828 0V9.263C28 8.571 27.439 8 26.759 8H8.552zM6.897 9.684c-.542 0-.542.842 0 .842h18.206c.237 0 .414.18.414.421v10.948c0 .56.836.556.828 0V10.947c0-.692-.561-1.263-1.242-1.263H6.897zM5.24 11.368c-.68 0-1.241.571-1.241 1.264v10.105C4 23.429 4.561 24 5.241 24h18.207c.68 0 1.242-.57 1.242-1.263V12.632c0-.693-.561-1.264-1.242-1.264H5.241zm0 .843h18.207c.237 0 .414.18.414.42v10.106c0 .24-.177.42-.414.42H5.241a.407.407 0 01-.413-.42V12.632c0-.241.177-.421.413-.421zm.828.842a.418.418 0 00-.414.42v1.685c0 .566.828.552.828 0v-1.263h1.241c.556 0 .543-.842 0-.842H6.07zm8.276 0c-2.51 0-4.552 2.078-4.552 4.631 0 2.553 2.043 4.632 4.552 4.632 2.51 0 4.552-2.079 4.552-4.632 0-2.553-2.043-4.631-4.552-4.631zm6.62 0c-.542 0-.556.842 0 .842h1.242v1.263c0 .552.827.566.827 0v-1.684a.418.418 0 00-.413-.421h-1.655zm-6.62.842c2.06 0 3.724 1.692 3.724 3.79 0 2.096-1.663 3.789-3.724 3.789-2.06 0-3.724-1.693-3.724-3.79s1.663-3.79 3.724-3.79zM6.069 19.79a.397.397 0 00-.414.42v1.684c0 .232.186.42.414.42h1.655c.543 0 .556-.841 0-.841H6.483V20.21a.403.403 0 00-.414-.42zm16.552 0a.403.403 0 00-.414.42v1.263h-1.241c-.557 0-.543.842 0 .842h1.655a.418.418 0 00.413-.421V20.21a.397.397 0 00-.413-.42z"
  }));
}

export default SvgMoney;